import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Container, Sidebar, Sidenav, Content, Nav, DOMHelper } from 'rsuite';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import NavToggle from './NavToggle';
import Header from '../Header';
import NavLink from '../NavLink';
import { Icon } from '@rsuite/icons';
import Brand from '../Brand';
// import { appNavs } from '@/config';
import ReviewPassIcon from '@rsuite/icons/ReviewPass';
import TextImageIcon from '@rsuite/icons/TextImage';
import BarLineChartIcon from '@rsuite/icons/BarLineChart';
import TrendIcon from '@rsuite/icons/Trend';
import AdminIcon from '@rsuite/icons/Admin';
import DetailIcon from '@rsuite/icons/Detail';
import GearIcon from '@rsuite/icons/Gear';
import TreemapIcon from '@rsuite/icons/Treemap';
import LocationIcon from '@rsuite/icons/Location';
import PeopleSpeakerIcon from '@rsuite/icons/PeopleSpeaker';
import PeoplesUploadedIcon from '@rsuite/icons/PeoplesUploaded';
import SingleSourceIcon from '@rsuite/icons/SingleSource';
import SettingIcon from '@rsuite/icons/Setting';
import PeopleBranchIcon from '@rsuite/icons/PeopleBranch';
import ExitIcon from '@rsuite/icons/Exit';
import PushMessageIcon from '@rsuite/icons/PushMessage';
import TreeIcon from '@rsuite/icons/Tree';
import ToolsIcon from '@rsuite/icons/Tools';
import SiteIcon from '@rsuite/icons/Site';
import EmailIcon from '@rsuite/icons/Email';
import TableColumnIcon from '@rsuite/icons/TableColumn';
import TagIcon from '@rsuite/icons/Tag';
import AbTestIcon from '@rsuite/icons/AbTest';
import ReviewIcon from '@rsuite/icons/Review';
import SettingHorizontalIcon from '@rsuite/icons/SettingHorizontal';
import StorageIcon from '@rsuite/icons/Storage';
import OperatePeopleIcon from '@rsuite/icons/OperatePeople';
import PublicOpinionIcon from '@rsuite/icons/PublicOpinion';
import AppSelectIcon from '@rsuite/icons/AppSelect';
import TouchIcon from '@rsuite/icons/Touch';
import globalIP from '@/GlobelIP';
import useUser from '../UseUser';
import VisibleIcon from '@rsuite/icons/Visible';
import ugr from '@/UGRoute';
import {
  MenuFoldOutlined, MenuUnfoldOutlined,
  DashboardOutlined,
  AppstoreOutlined,
  TagsOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  TeamOutlined,
  BarChartOutlined,
  MailOutlined,
  FolderOpenOutlined,
  BookOutlined,
  ProfileOutlined,
  DatabaseOutlined,
  ContainerOutlined,
  NodeIndexOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
const { getHeight, on } = DOMHelper;


const NavItem = (props) => {
  const { title, eventKey, to, onSelect, icon, ...rest } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // First run custom logic (like exitSettings)
    if (onSelect) onSelect();
    // Then navigate if route given
    if (to) navigate(to);
  };
  // console.log(location.pathname,to)
  const isActive =
    to && (location.pathname === to);
  return (
    <Nav.Item
      eventKey={eventKey}
      onClick={handleClick}
      active={isActive}
      {...rest}
      style={{ cursor: "pointer" }}
    >
      {icon} {title}
    </Nav.Item>
  );
};

export interface NavItemData {
  eventKey: string;
  title: string;
  icon?: any;
  to?: string;
  target?: string;
  children?: NavItemData[];
}

export interface FrameProps {
  navs: NavItemData[];
  children?: React.ReactNode;
}

const Frame = (props: FrameProps) => {
  const navigate = useNavigate();
  const [lastRoute, setLastRoute] = useState(null);
  const location = useLocation();
  const { user } = useUser();
  const { navs } = props;
  const [expand, setExpand] = useState(false);
  const [img] = useState(0);

  const [windowHeight, setWindowHeight] = useState(getHeight(window));

  const [showSettings, setShowSettings] = useState(false);
  const [previousNavs, setPreviousNavs] = useState([]);

  useEffect(() => {
    setWindowHeight(getHeight(window));
    const resizeListenner = on(window, 'resize', () => setWindowHeight(getHeight(window)));

    return () => {
      resizeListenner.off();
    };
  }, []);

  const containerClasses = classNames('page-container', {
    'container-full': !expand
  });

  const navBodyStyle: React.CSSProperties = expand
    ? { height: windowHeight - 112, overflow: 'auto' }
    : {};

  const roe = () => {
    if (expand == true) {
      setExpand(!expand);
    }
  };
  if (expand == false) {
    img;
  }
  const toggleSettings = () => {
    if (showSettings) {
      setShowSettings(false);
    } else {
      setPreviousNavs([...navs]);
      setLastRoute(location.pathname)
      setShowSettings(true);
    }
  };

  const exitSettings = () => {
    setShowSettings(false);
    setPreviousNavs([]);
  };

  const activeNavs1 = [
    (user.MProduct || user.Category === "Admin") && {
      eventKey: "dashboard",
      icon: <Icon as={BarLineChartIcon} />,
      title: "Dashboard",
      to: `/${ugr}/dashboard`,
    },
    {
      eventKey: "product",
      icon: <Icon as={TextImageIcon} />,
      title: "PIM",
      children: [
        (user.MProduct || user.Category === "Admin") && {
          eventKey: "create-product",
          icon: <Icon as={TextImageIcon} />,
          title: "Products",
          to: `/${ugr}/products`,
        },
        (user.PriceList || user.Category === "Admin") && {
          eventKey: "price-list",
          icon: <Icon as={TouchIcon} />,
          title: "Price List",
          to: `/${ugr}/pricelist`,
        },
        {
          eventKey: "costing",
          icon: <Icon as={BarLineChartIcon} />,
          title: "Costing",
          to: `/${ugr}/product-Selection-Page`,
        },
      ].filter(Boolean),
    },
    (user.CATcreate !== false ||
      user.MCatalogue ||
      user.MCollection ||
      user.Category === "Admin") && {
      eventKey: "catalogues",
      icon: <Icon as={TreemapIcon} />,
      title: "Catalogues",
      children: [
        (user.CATcreate !== false || user.Category === "Admin") && {
          eventKey: "create-catalogue",
          icon: <Icon as={DetailIcon} />,
          title: "Create Catalogue",
          to: `/${ugr}/selection`,
        },
        (user.MCatalogue || user.Category === "Admin") && {
          eventKey: "manage-catalogue",
          icon: <Icon as={DetailIcon} />,
          title: "All Catalogues",
          to: `/${ugr}/manageCatalogue`,
        },
        (user.MCollection || user.Category === "Admin") && {
          eventKey: "manage-collection",
          icon: <Icon as={TreemapIcon} />,
          title: "Collection",
          to: `/${ugr}/manageCollection`,
        },
      ].filter(Boolean),
    },
    {
      eventKey: "sales",
      icon: <Icon as={SingleSourceIcon} />,
      title: "Sales & Enquiries",
      children: [
        (user.MQuotation || user.Category === "Admin") && {
          eventKey: "enquiry-quotation",
          icon: <Icon as={ProfileOutlined} />,
          title: "Quotations",
          to: `/${ugr}/manageOrdQ`,
        },
        (user.MEnquiry || user.Category === "Admin") && {
          eventKey: "enquiries",
          icon: <Icon as={MailOutlined} />,
          title: "Enquiries",
          to: `/${ugr}/enqury-tracker`,
        },
        (user.MBuyer || user.Category === "Admin") && {
          eventKey: "buyers",
          icon: <Icon as={TeamOutlined} />,
          title: "Buyers",
          to: `/${ugr}/addbuyer`,
        },
      ].filter(Boolean),
    },
    {
      eventKey: "marketing",
      icon: <Icon as={TrendIcon} />,
      title: "Marketing",
      children: [
        (user.MEmarketing || user.Category === "Admin") && {
          eventKey: "e-marketing",
          icon: <Icon as={MailOutlined} />,
          title: "E-Marketing",
          to: `/${ugr}/marketing`,
        },
        (user.MGreeting || user.Category === "Admin") && {
          eventKey: "greetings",
          icon: <Icon as={PublicOpinionIcon} />,
          title: "Greetings",
          to: `/${ugr}/greetings`,
        },
      ].filter(Boolean),
    },
    (user.MFair || user.Category === "Admin") && {
      eventKey: "manageFair",
      icon: <Icon as={AppSelectIcon} />,
      title: "Manage Fair",
      to: `/${ugr}/manageFair`,
    },
    {
      eventKey: "setting",
      icon: <Icon as={SettingIcon} />,
      title: "Settings",
      children: [
        {
          eventKey: "company",
          icon: <Icon as={TreeIcon} />,
          title: "Company Profile",
          to: `/${ugr}/companyMaster`,
        },
        (user.MBuyer || user.Category === "Admin") && {
          eventKey: "addUsers",
          icon: <Icon as={AdminIcon} />,
          title: "User Management",
          to: `/${ugr}/adduser`,
        },
        (user.PMaster || user.Category === "Admin") && {
          eventKey: "master",
          icon: <Icon as={PushMessageIcon} />,
          title: "Product Master",
          to: `/${ugr}/master`,
        },
        {
          eventKey: "masterAtrributes",
          icon: <Icon as={TableColumnIcon} />,
          title: "Attributes Master",
          to: `/${ugr}/masterAtrributes`,
        },
        {
          eventKey: "catalogueTemp",
          icon: <Icon as={StorageIcon} />,
          title: "Templates Library",
          to: `/${ugr}/templates`,
        },
      ].filter(Boolean),
    },
  ].filter(Boolean);

  return (
    <Container className="frame">
      <Sidebar className="ex" style={{ display: 'flex', flexDirection: 'column', height: '-webkit-fill-available' }} width={expand ? 220 : 56} collapsible >

        <Sidenav.Header className="header">
          {/* <Brand /> */}
          <NavToggle expand={expand} onChange={() => setExpand(!expand)}></NavToggle>
        </Sidenav.Header>
        <Sidenav expanded={expand} appearance="subtle" defaultOpenKeys={['1', '2']}>
          <Sidenav.Body style={navBodyStyle}>
            <Nav>
              {activeNavs1.map(item => {
                if (item.children) {
                  return (
                    <Nav.Menu
                      key={item.eventKey}
                      placement="rightStart"
                      // trigger="hover"
                      title={item.title}
                      icon={item.icon}
                    >
                      {item.children.map(child => (
                        <NavItem key={child.eventKey} {...child} />
                      ))}
                    </Nav.Menu>
                  );
                }
                return <NavItem key={item.eventKey} {...item} />;
              })}
            </Nav>
          </Sidenav.Body>

        </Sidenav>
        {/* <NavToggle expand={expand} onChange={() => setExpand(!expand)} /> */}
      </Sidebar>

      <Container className={containerClasses}>
        <Header expand={expand} />
        <Content>
          <Outlet />
        </Content>
      </Container>
    </Container>
  );
};

export default React.memo(Frame);
